import { createSlice } from "@reduxjs/toolkit";
import { ApiStatus } from "../../types/api/status";
import { RootState } from "../store";
import { SaleChannel, saleChannelType } from "../../types/slices/saleChannelType";

const initialState:saleChannelType = {
    status: ApiStatus.FETCHED,
    salesChannels: [],
    editSaleChannel: {} as SaleChannel,
    errorMessage: undefined,
    action: ''
}

const saleChannelSlice = createSlice({
    name: 'saleChannelSlice',
    initialState,
    reducers: {
        onFetchSalesChannels (state, { payload }: { payload: SaleChannel[]}) {
            state.status = ApiStatus.FETCHED
            state.salesChannels = payload
            state.errorMessage = undefined
        },
        onSetEditSaleChannel (state, { payload }: { payload: SaleChannel }) {
            state.editSaleChannel = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
            state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
            state.action = payload
        },
    }
})

export const selectSaleChannelState = (state: RootState) => state.saleChannelSlice
export default saleChannelSlice.reducer

export const {
    onFetchSalesChannels,
    onSetEditSaleChannel,
    changeStatus,
    setAction,
} = saleChannelSlice.actions